require('./brokerConvenienceMiFIDTestStepSuccess.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @components
const BrokerMiFIDAllowDisclaimerContinue = require('mifid/components/brokerMiFIDAllowDisclaimerContinue/brokerMiFIDAllowDisclaimerContinue');
const BrokerMiFIDAllowDisclaimerAcceptingResponsability = require('mifid/components/brokerMiFIDAllowDisclaimerAcceptingResponsability/brokerMiFIDAllowDisclaimerAcceptingResponsability');
const {
    BrokerConvenienceMiFIDTestStepOmittedTest
} = require('mifid/components/brokerConvenienceMiFIDTestWizard/brokerConvenienceMiFIDTestStepOmittedTest/brokerConvenienceMiFIDTestStepOmittedTest');
const BrokerMiFIDNotAllowed = require('mifid/components/brokerMiFIDNotAllowed/brokerMiFIDNotAllowed');
const BrokerAlreadyPerformedMiFIDTest = require('mifid/components/brokerAlreadyPerformedMiFIDTest/brokerAlreadyPerformedMiFIDTest');
const { BrokerMiFID2Disclaimer } = require('mifid/components/brokerMiFID2Disclaimer/brokerMiFID2Disclaimer');

// @helpers
const PersonalDataHelper = require('utilities/personalDataHelper');

// @actions
const BrokerConvenienceMiFIDTestStepSuccessAction = require('mifid/actions/brokerConvenienceMiFIDTest/brokerConvenienceMiFIDTestStepSuccess');
const BrokerConvenienceMiFIDTestActions = require('mifid/actions/brokerConvenienceMiFIDTest');
const BrokerRequestFinancialOperationChangeActions = require('actions/brokerRequestFinancialOperationChange');
const BrokerRightsBuyActions = require('actions/brokerRightsBuy');
const BrokerSubscriptionActions = require('actions/brokerSubscription');
const BrokerStocksPurchaseOrderActions = require('actions/brokerStocksPurchaseOrder');
const BrokerCashChargeActions = require('actions/brokerCashCharge');
const BrokerCreateTransferOfDerivativesAction = require('actions/brokerCreateTransferOfDerivatives');
const InternalTransferFundActions = require('actions/brokerInternalTransferFunds');
const BrokerExternalTransferFundActions = require('actions/externalTransferFund');
const BrokerMiFIDUSPersonActions = require('mifid/actions/brokerMiFIDUSPerson');

// @constants
const {
    BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_REQUEST_CHANGE,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPV,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPA,
    BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_CASH_CHARGE,
    BROKER_CONVENIENCE_MIFID_TEST_FUTURES_CREATE,
    BROKER_MIFID_2_DISCLAIMER_ACTION,
    BROKER_MIFID_ALLOW_DISCLAIMER_CONTINUE,
    BROKER_MIFID_ALLOW_DISCLAIMER_ACCEPTING_RESPONSABILITY,
    BROKER_MIFID_ALLOW_DISCLAIMER_REPEAT_SENTENCE,
    BROKER_MIFID_NOT_ALLOWED,
    BROKER_MIFID_ACTION_MANUAL_TEST,
    MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_WIZARD_URL,
    BROKER_CONVENIENCE_MIFID_FUND,
    MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND,
    BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND,
    MYPROFILE_BROKER_STOCKS_SALE_ORDER_WIZARD_URL,
    BROKER_CORPOTATE_OPERATIONS_PURCHASE_ORDER_URL,
    MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL
} = require('constants/index');

class BrokerConvenienceMiFIDTestStepSuccess extends React.Component {
    constructor(props) {
        super(props);

        this.handleContinueOperation = this.handleContinueOperation.bind(this);
        this.handleGoToMakeTest = this.handleGoToMakeTest.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.continueToCorporativeOperationOpa = this.continueToCorporativeOperationOpa.bind(this);
    }

    continueFuture() {
        const { history, immBrokerConvenienceMiFIDTest, onCreateTransferOfDerivatives } = this.props;
        const originContractNumber = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'originContractNumber'
        ]);

        onCreateTransferOfDerivatives(originContractNumber);
        history.push(MY_PROFILE_BROKER_DERIVATIVES_MOVEMENTS_WIZARD_URL);
    }

    continueToCorporativeOperationBuyRights() {
        const { history, immBrokerConvenienceMiFIDTest, onContinueToCorporateOperationBuyRights, startCorporativeOperationSubscriptionFromMifid } = this.props;
        const operationData = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'operationData']);

        onContinueToCorporateOperationBuyRights(operationData, history);

        const immSelectedContract = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'selectedContract']);
        const immSelectedOperation = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'selectedOperation']);

        startCorporativeOperationSubscriptionFromMifid(
            immSelectedContract ? immSelectedContract.toJS() : {},
            immSelectedOperation ? immSelectedOperation.toJS() : {}
        );
    }


    continueToCorporativeOperationCashCharge() {
        const { history, immBrokerConvenienceMiFIDTest, startCorporativeOperationCashCharge } = this.props;
        const owner = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'owner']);
        const contract = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'contract']);
        const operation = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'operation']);
        const cuenta = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'cuenta']);
        const walletAccountType = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'walletAccountType'
        ]);

        startCorporativeOperationCashCharge(cuenta, operation, contract, owner, walletAccountType);
        history.push('/myprofile/broker/cash-charge/wizard');
    }

    continueToCorporativeOperationChangeRequest() {
        const {
            history,
            immBrokerConvenienceMiFIDTest,
            startCorporativeOperationRequestChange
        } = this.props;
        const owner = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'owner']);
        const contract = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'contract']);
        const operation = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'operation']);
        const associatedAccount = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'associatedAccount'
        ]);
        const cuenta = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'cuenta']);
        const walletAccountType = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'walletAccountType'
        ]);
        const isLoaded = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'isLoaded']);

        startCorporativeOperationRequestChange(
            owner,
            contract,
            operation,
            associatedAccount,
            cuenta,
            walletAccountType,
            isLoaded
        );
        history.push('/myprofile/broker/request-financial-operation-change/wizard');
    }

    continueToCorporativeOperationOpv() {
        const { history, immBrokerConvenienceMiFIDTest, startCorporativeOperationOpv } = this.props;
        const owner = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'owner']);
        const contract = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'contract']);
        const operation = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'operation']);
        const associatedAccount = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'associatedAccount'
        ]);
        const cuenta = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'cuenta']);
        const walletAccountType = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'walletAccountType'
        ]);
        const isLoaded = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'isLoaded']);

        startCorporativeOperationOpv(
            cuenta,
            operation,
            contract,
            owner,
            associatedAccount,
            walletAccountType,
            isLoaded
        );
        history.push(BROKER_CORPOTATE_OPERATIONS_PURCHASE_ORDER_URL);
    }

    continueToCorporativeOperationOpa() {
        this.props.history.push(MYPROFILE_BROKER_STOCKS_SALE_ORDER_WIZARD_URL);
    }

    continueToCorporativeOperationSubscription() {
        const { history, immBrokerConvenienceMiFIDTest, startCorporativeOperationSubscriptionFromMifid } = this.props;
        const immSelectedContract = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'selectedContract']);
        const immSelectedOperation = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'selectedOperation']);

        startCorporativeOperationSubscriptionFromMifid(
            immSelectedContract ? immSelectedContract.toJS() : {},
            immSelectedOperation ? immSelectedOperation.toJS() : {}
        );

        history.push(MYPROFILE_BROKER_SUBSCRIPTION_WIZARD_URL);
    }

    continueToExternalTransferFund() {
        const { history, immBrokerConvenienceMiFIDTest, onContinueToExternalTransferFund } = this.props;
        const externalTransferFundState = immBrokerConvenienceMiFIDTest.getIn(
            ['operationData', 'externalTransferFundState']
        );

        onContinueToExternalTransferFund(externalTransferFundState, history);
    }

    continueToFund() {
        const { history, immBrokerConvenienceMiFIDTest } = this.props;
        const fundId = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'fundId']);

        history.push(`/myprofile/broker/buyInvestmentFunds/${fundId}`);
    }

    continueToInternalTransferFund() {
        const { history, immBrokerConvenienceMiFIDTest } = this.props;

        const originFund = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'originFund']);
        const destinationFund = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'destinationFund'
        ]);
        const mifidId = immBrokerConvenienceMiFIDTest.get('productId');
        const displayDisclaimer = immBrokerConvenienceMiFIDTest.getIn([
            'operationData',
            'displayMifidDisclaimer'
        ]);

        this.props.onContinueToInternalTransferFund(
            originFund,
            destinationFund,
            mifidId,
            displayDisclaimer
        );
        history.push(MYPROFILE_BROKER_INTERNAL_TRANSFER_FUND);
    }

    handleCancel() {
        const { history, immBrokerConvenienceMiFIDTest } = this.props;
        const operationType = immBrokerConvenienceMiFIDTest.get('operationType');

        switch (operationType) {
            case BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND:
                const externalTransferFundState = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'externalTransferFundState']);
                this.props.onCancelToExternalTransferFund(externalTransferFundState, history);

                break;
            default: {
                const cancelPath = immBrokerConvenienceMiFIDTest.get('cancelPath');

                if (!immBrokerConvenienceMiFIDTest.get('isCancelPathAbsolute')) {
                    history.replace(cancelPath); // This doesn't consider the domain
                } else {
                    window.location.replace(cancelPath); // Redirects to URLs with different hostnames
                }
                break;
            }
        }
    }

    handleContinueOperation() {
        const { history, immBrokerConvenienceMiFIDTest, onMiFIDResultDisplayed } = this.props;
        const continueUrl = immBrokerConvenienceMiFIDTest.getIn(['urlContinueOperation', 0]);
        const operationType = immBrokerConvenienceMiFIDTest.get('operationType');

        onMiFIDResultDisplayed();

        switch (operationType) {
            case BROKER_CONVENIENCE_MIFID_TEST_EXTERNAL_TRANSFER_FUND:
                this.continueToExternalTransferFund();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_INTERNAL_TRANSFER_FUND:
                this.continueToInternalTransferFund();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_RIGHTS_BUY:
                this.continueToCorporativeOperationBuyRights();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_SUBSCRIPTION:
                this.continueToCorporativeOperationSubscription();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_REQUEST_CHANGE:
                this.continueToCorporativeOperationChangeRequest();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPV:
                this.continueToCorporativeOperationOpv();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_OPA:
                this.continueToCorporativeOperationOpa();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_OPERATION_TYPE_CORPORATE_OPERATIONS_CASH_CHARGE:
                this.continueToCorporativeOperationCashCharge();
                break;
            case BROKER_CONVENIENCE_MIFID_TEST_FUTURES_CREATE:
                this.continueFuture();
                break;
            /* Disabled
            case BROKER_CONVENIENCE_MIFID_TEST_FUTURES_PLATFORM_ACCESS:
                this.continueFuturesAccessPlatform();
                break;*/
            case BROKER_CONVENIENCE_MIFID_FUND:
                this.continueToFund();
                break;
            default:
                if (continueUrl) {
                    history.replace(continueUrl);
                }
                break;
        }
    }

    handleGoToMakeTest() {
        const { history, onGoToMakeTest, immBrokerConvenienceMiFIDTest} = this.props;
        const productName = immBrokerConvenienceMiFIDTest.get('productName');
        const productURL = immBrokerConvenienceMiFIDTest.get('productUrl');
        const productId = immBrokerConvenienceMiFIDTest.get('productId');
        const to = immBrokerConvenienceMiFIDTest.get('urlContinueOperation');
        const productType = immBrokerConvenienceMiFIDTest.getIn(['operationData', 'productType']);
        onGoToMakeTest(history, productName, productURL, productId, to, {productType:productType, skipIntermediateScreens:true});
    }

    render() {
        const {
            immProfileFields,
            immBrokerConvenienceMiFIDTest,
            immBrokerMiFIDProducts
        } = this.props;

        const clientEmail = PersonalDataHelper.getEmail(immProfileFields);
        const disclaimerText = immBrokerConvenienceMiFIDTest.get('disclaimer');
        const resultText = immBrokerConvenienceMiFIDTest.get('resultText');
        const isTestOmitted = immBrokerConvenienceMiFIDTest.get('operateOmittingTest');

        switch (immBrokerConvenienceMiFIDTest.get('action')) {
            case BROKER_MIFID_2_DISCLAIMER_ACTION:
                return (
                    <div className="col-xs-12">
                        <BrokerMiFID2Disclaimer
                            onContinueOperation={this.handleContinueOperation}
                            onCancel={this.handleCancel}
                            onStartConvenienceMiFIDTest={this.props.onRetakeTest}
                            isIntermediateScreen={this.props.isIntermediateScreen}
                        />
                    </div>
                );
            case BROKER_MIFID_ALLOW_DISCLAIMER_CONTINUE:
                return (
                    <div className="col-xs-12">
                        <BrokerMiFIDAllowDisclaimerContinue
                            clientEmail={clientEmail}
                            onContinueOperation={this.handleContinueOperation}
                            disclaimerText={disclaimerText}
                            resultText={resultText}
                            onCancel={this.handleCancel}
                        />
                    </div>
                );
            case BROKER_MIFID_ALLOW_DISCLAIMER_ACCEPTING_RESPONSABILITY:
                return (
                    <div className="col-xs-12">
                        <BrokerMiFIDAllowDisclaimerAcceptingResponsability
                            clientEmail={clientEmail}
                            onContinueOperation={this.handleContinueOperation}
                            disclaimerText={disclaimerText}
                            resultText={resultText}
                            isTestOmitted={isTestOmitted}
                            onStartConvenienceMiFIDTest={this.handleGoToMakeTest}
                            onCancel={this.handleCancel}
                        />
                    </div>
                );
            case BROKER_MIFID_ALLOW_DISCLAIMER_REPEAT_SENTENCE:
                const repeatSentence = immBrokerConvenienceMiFIDTest.get('repeatSentence');

                return (
                    <div className="col-xs-12">
                        <BrokerConvenienceMiFIDTestStepOmittedTest
                            onContinueOperation={this.handleContinueOperation}
                            disclaimerText={disclaimerText}
                            resultText={resultText}
                            repeatSentenceText={repeatSentence}
                            isTestOmitted={isTestOmitted}
                            clientEmail={clientEmail}
                            onCancel={this.handleCancel}
                        />
                    </div>
                );
            case BROKER_MIFID_NOT_ALLOWED:
                return (
                    <div className="col-xs-12">
                        <BrokerMiFIDNotAllowed
                            disclaimerText={disclaimerText}
                            resultText={resultText}
                            clientEmail={clientEmail}
                            isTestOmitted={isTestOmitted}
                            cancelButtonAvailable={true}
                            onCancel={this.handleCancel}
                        />
                    </div>
                );
            case BROKER_MIFID_ACTION_MANUAL_TEST:
                return (
                    <div className="col-xs-12">
                        <BrokerMiFIDNotAllowed
                            disclaimerText={disclaimerText}
                            resultText={resultText}
                            clientEmail={clientEmail}
                            isTestOmitted={isTestOmitted}
                            cancelButtonAvailable={false}
                            onCancel={this.handleCancel}
                        />
                    </div>
                );
            default:
                const productId = immBrokerConvenienceMiFIDTest.get('productId');
                const alreadyPerformedDisclaimer = immBrokerMiFIDProducts.getIn([
                    'products',
                    productId,
                    'disclaimer'
                ]);
                const alreadyPerformedDate = immBrokerMiFIDProducts.getIn([
                    'products',
                    productId,
                    'date'
                ]);

                return (
                    <div className="col-xs-12">
                        <BrokerAlreadyPerformedMiFIDTest
                            onCancel={this.handleCancel}
                            onContinueOperation={this.handleContinueOperation}
                            disclaimerText={alreadyPerformedDisclaimer}
                            date={alreadyPerformedDate}
                        />
                    </div>
                );
        }
    }
}

BrokerConvenienceMiFIDTestStepSuccess.propTypes = {
    history: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immBrokerConvenienceMiFIDTest: PropTypes.object.isRequired,
    onOperateOmittingTest: PropTypes.func.isRequired,
    startCorporativeOperationRequestChange: PropTypes.func.isRequired,
    startCorporativeOperationSubscriptionFromMifid: PropTypes.func.isRequired,
    startCorporativeOperationOpv: PropTypes.func.isRequired,
    startCorporativeOperationCashCharge: PropTypes.func.isRequired,
    onCreateTransferOfDerivatives: PropTypes.func.isRequired,
    immBrokerMiFIDProducts: PropTypes.object.isRequired,
    onMiFIDResultDisplayed: PropTypes.func.isRequired,
    onContinueToInternalTransferFund: PropTypes.func.isRequired,
    onGoToMakeTest: PropTypes.func.isRequired,
    onContinueToExternalTransferFund: PropTypes.func.isRequired,
    onCancelToExternalTransferFund: PropTypes.func.isRequired,
    onContinueToCorporateOperationBuyRights: PropTypes.func.isRequired,
    onRetakeTest: PropTypes.func.isRequired,
    isIntermediateScreen: PropTypes.bool
};

module.exports.constructor = BrokerConvenienceMiFIDTestStepSuccess;
module.exports.BrokerConvenienceMiFIDTestStepSuccess = connect(
    state => ({
        immProfileFields: state.profile,
        immBrokerConvenienceMiFIDTest: state.brokerConvenienceMiFIDTest,
        immBrokerMiFIDProducts: state.brokerMiFIDProducts
    }),
    {
        onOperateOmittingTest: BrokerConvenienceMiFIDTestStepSuccessAction.operateOmittingTest,
        startCorporativeOperationRequestChange:
            BrokerRequestFinancialOperationChangeActions.startOperation,
        startCorporativeOperationSubscriptionFromMifid: BrokerSubscriptionActions.startFromMifid,
        startCorporativeOperationOpv: BrokerStocksPurchaseOrderActions.start,
        startCorporativeOperationCashCharge: BrokerCashChargeActions.start,
        onCreateTransferOfDerivatives: BrokerCreateTransferOfDerivativesAction.beginOperation,
        onMiFIDResultDisplayed: BrokerConvenienceMiFIDTestActions.resultDisplayed,
        onContinueToInternalTransferFund: InternalTransferFundActions.continueInternalTransferFundFromMifid,
        onGoToMakeTest: BrokerConvenienceMiFIDTestActions.start,
        onBeforeContinueOperation: BrokerMiFIDUSPersonActions.beforeContinueOperation,
        onContinueToExternalTransferFund: BrokerExternalTransferFundActions.continueFromMifid,
        onCancelToExternalTransferFund: BrokerExternalTransferFundActions.cancelMifid,
        onContinueToCorporateOperationBuyRights: BrokerRightsBuyActions.continueOperationFromMifid,
        onFetchInfo: BrokerMiFIDUSPersonActions.fetchInfo,
    }
)(withRouter(BrokerConvenienceMiFIDTestStepSuccess));
